// For more information:
// * https://github.com/snapappointments/bootstrap-select
// * https://github.com/truckingsim/Ajax-Bootstrap-Select

import SelectPicker from 'bootstrap-select';
import AjaxBootstrapSelect from 'ajax-bootstrap-select';
import {each, isInteger} from 'lodash';

$.selectpicker = SelectPicker;
$.selectpicker.ajaxSelectPicker = AjaxBootstrapSelect;
const $selectors = $('[data-selector]');

export default class BootstrapSelect {

    static init() {
        each($selectors, (selector) => {
            const $selector = $(selector);
            const placeholder = $selector.data('placeholder');
            const $selectPicker = $selector.selectpicker({
                noneSelectedText: placeholder
            });
            // Live search place
            if ($selector.data('liveSearchPlace')) {
                $selectPicker.ajaxSelectPicker({
                    locale: {
                        emptyTitle: placeholder,
                        searchPlaceholder: null,
                        statusTooShort: '3 caractères min.',
                        statusInitialized: 'Commencez à taper pour lancer la recherche',
                        statusSearching: 'Recherche en cours...',
                        statusNoResults: 'Aucun résultat trouvé.',
                        currentlySelected: 'Sélectionné :'
                    },
                    minLength: 3,
                    ajax: {
                        url: 'https://geo.api.gouv.fr/communes',
                        type: 'GET',
                        dataType: 'json',
                        data: () => {
                            const searched = $selector.parent('.bootstrap-select')
                                .find('.bs-searchbox input[type="search"]')
                                .val();
                            let params = {fields: 'nom,code,codesPostaux,codeDepartement'};
                            const searchedTermIsPostalCode = isInteger(parseInt(searched));
                            if (! searchedTermIsPostalCode) {
                                params.nom = searched;
                            }
                            if (searchedTermIsPostalCode) {
                                params.codePostal = parseInt(searched);
                            }

                            return params;
                        }
                    },
                    preprocessData: (results) => {
                        let options = [];
                        each(results, (result) => {
                            each(result.codesPostaux.sort(), (postalCode) => {
                                if (! window.app.search_departments.includes(result.codeDepartement)) {
                                    return;
                                }

                                options.push({
                                    value: result.nom + ' (' + postalCode + ')',
                                    text: result.nom + ' (' + postalCode + ')'
                                });
                            });
                        });

                        return options;
                    }
                });
            }
            // Append default selected options
            const defaultSelectedOptionsToAppend = $selector.data('defaultSelectedOptions');
            if (defaultSelectedOptionsToAppend) {
                each(defaultSelectedOptionsToAppend, (defaultSelectedOptionToAppend) => {
                    $selector.append(
                        '<option value="' + defaultSelectedOptionToAppend + '" selected>'
                        + defaultSelectedOptionToAppend
                        + '</option>'
                    );
                });
                $selector.selectpicker('refresh');
                $selector.parent('.bootstrap-select')
                    .find('.dropdown-toggle .filter-option-inner-inner')
                    .text(defaultSelectedOptionsToAppend.length + ' sélectionnés');
            }
        });
    }

}
